import { render, staticRenderFns } from "./legal-page.vue?vue&type=template&id=1dfdfd1a&scoped=true&"
import script from "./legal-page.vue?vue&type=script&lang=js&"
export * from "./legal-page.vue?vue&type=script&lang=js&"
import style0 from "./legal-page.vue?vue&type=style&index=0&id=1dfdfd1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dfdfd1a",
  null
  
)

export default component.exports